module.exports = __webpack_public_path__ + "media/images/features/3/about-f625e55e4d46435215c817c492c9ac44.jpg";